

































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import * as api from '@/services/ApiService'
import appManager from '@/services/AppManager'
import FormTextField from '@/components/FormTextField.vue'
import { extractResponseErrorMessage } from '@/services/ApiService'
import PaymentCardComponent from '@/components/PaymentCardComponent.vue'

@Component({
    components: {
        FormTextField,
        PaymentCardComponent
    }
})
export default class AddPaymentMethodDialog extends Vue {
    @Prop()
    value: boolean|undefined // true to show the dialog
    @Prop()
    companyId: string|undefined
    @Prop()
    onCloseRequested: ((added?: boolean) => void)|undefined
    isDefaultPaymentMethod: boolean = true
    formErrorMessage: string|null = null
    isAdding: boolean = false

    onCancelPressed() {
        if (this.onCloseRequested)
            this.onCloseRequested()
    }

    async onPaymentMethodCreated(paymentMethodId: string): Promise<void> {
        if (this.formErrorMessage)
            return

        this.isAdding = true

        try {
            // if the user entered a fixed amount, convert it from dollars to cents
            await api.attachPaymentMethod({
                companyId: this.companyId!!,
                stripePaymentMethodId: paymentMethodId,
                isDefaultPaymentMethod: this.isDefaultPaymentMethod
            })

            this.formErrorMessage = null

            if (this.onCloseRequested)
                this.onCloseRequested(true)

            appManager.alertManager.publishSuccess('Payment method successfully added')
        } catch (error) {
            this.formErrorMessage = extractResponseErrorMessage(error) || 'Error adding payment method. Please try again later.'
        }

        // go ahead and log in
        this.isAdding = false
    }
}
